/**
 * Labstep
 *
 * @module components/Entity/Action/Update/Checkbox
 * @desc Entity Update action with checkbox
 */

import { EntityActionUpdateContainer as EntityActionUpdate } from 'labstep-web/components/Entity/Action/Update';
import type {
  EntityActionUpdateCheckboxProps,
  EntityType,
} from './types';

export const EntityActionUpdateCheckbox = <
  TEntity extends EntityType,
>({
  entity,
  field,
  disabled = false,
  toggle,
  radio,
  optimistic,
  isChecked,
  dataCy,
  fieldValue,
}: EntityActionUpdateCheckboxProps<TEntity>) => {
  const checked =
    typeof isChecked === 'boolean' ? isChecked : !!entity[field];
  let body: any = { [field]: !checked };
  if (fieldValue) {
    body = { [field]: fieldValue };
  }

  return (
    <EntityActionUpdate
      entityName={entity.entityName}
      id={entity.idAttr}
      body={body}
      optimistic={optimistic}
      actionComponentProps={({ canEdit }) => ({
        type: 'checkbox',
        dataCy,
        elementProps: {
          checked,
          toggle,
          radio,
        },
        disabled: !canEdit || disabled,
      })}
    />
  );
};
